var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label-development"},[_c('span',[_vm._v("DESARROLLADO POR ")]),_vm._v(" "),_c('img',{attrs:{"src":'img/pub/logo-az.png',"alt":"Logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }